import { useRef } from 'react'

const useViewButton = () => {
  const RefVertification= useRef<any>(null)
  const observeIntersection = (target: any, callback: any) => {
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        //ref와 스크롤이 교차될때 true반환 나머지 false
        callback(!entry.isIntersecting);
      });
    });
    if(target) observer.observe(target);
}
  return { RefVertification, observeIntersection }
}

export default useViewButton
